const Dashboard = "/";
const Login = "/login";
const Admins = "/admins";
const AdminsCreate = "/admins/create";
const AdminsDetail = "/admins/:id";
const AdminsInvite = "/admins/invite";
const NotFound = "*";

// 도장 정보 관리
const CompanyStamp = "/company-stamp";
const CompanyStampDetail = "/company-stamp/:id";
const CompanyStampUpdate = "/company-stamp/update";

// 구독 상품 관리
const Subscription = "/subscription";
const SubscriptionCreate = "/subscription/create";
const SubscriptionDetail = "/subscription/:id";
const SubscriptionUpdate = "/subscription/update";

// 템플릿 관리
const Template = "/template";
const TemplateCreate = "/template/create";
const TemplateDetail = "/template/:id";
const TemplateUpdate = "/template/update";

// 분할결제 설정 관리
const InstallmentSetting = "/installment-setting";
const InstallmentSettingCreate = "/installment-setting/create";
const InstallmentSettingDetail = "/installment-setting/:id";

// 이메일 대량 발송 관리
const BulkEmail = "/bulk-email";
const BulkEmailSend = "/bulk-email/send";

// QNA 챗봇 컨텐츠 관리
const SuperChatContent = "/chat/content";
const SuperChatContentCreate = "/chat/content/create";
const SuperChatContentDetail = "/chat/content/:id";
const SuperChatContentCreateContent = "/chat/qna-content-create";
const SuperChatContentCreatePrompt = "/chat/qna-prompt-create";
const SuperChatPromptDetail = "/chat/prompt/:id";

// QNA 챗봇 로그 관리
const SuperChatLogDashboard = "/chat/log";
const SuperChatLogSessions = "/chat/log/sessions";
const SuperChatLogSessionDetail = "/chat/log/sessions/:sessionId";

export default {
  Dashboard,
  Login,
  Admins,
  AdminsCreate,
  AdminsDetail,
  NotFound,
  CompanyStamp,
  CompanyStampDetail,
  CompanyStampUpdate,
  Subscription,
  SubscriptionCreate,
  SubscriptionDetail,
  SubscriptionUpdate,
  Template,
  TemplateCreate,
  TemplateDetail,
  TemplateUpdate,
  InstallmentSetting,
  InstallmentSettingCreate,
  InstallmentSettingDetail,
  AdminsInvite,
  BulkEmail,
  BulkEmailSend,
  SuperChatContent,
  SuperChatContentCreate,
  SuperChatContentDetail,
  SuperChatContentCreateContent,
  SuperChatContentCreatePrompt,
  SuperChatPromptDetail,
  SuperChatLogDashboard,
  SuperChatLogSessions,
  SuperChatLogSessionDetail,
};
